import { render } from "./payment-icons.vue?vue&type=template&id=7f8a04c1"
import script from "./payment-icons.vue?vue&type=script&lang=js"
export * from "./payment-icons.vue?vue&type=script&lang=js"

import "./payment-icons.vue?vue&type=style&index=0&id=7f8a04c1&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__